module.exports = __webpack_public_path__ + "img/Cresa-logo-landscape.ee546b1a.png";